import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

interface titleProps {
    title: any;
    actions?: [{}]; 
}

const ModalTitle = (props: titleProps) => {
    const theme = useTheme();
    return (
        <>
        <Toolbar />
        <AppBar 
          position='static'
          sx={{
            boxShadow: 'none',
            borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
            background: theme.palette.background.paper,
            padding:2,
            display:'flex', 
            flexDirection:'row', 
            justifyContent: 'space-between', 
            alignItems: 'center',
          }}
        >
        <Box sx={{
            display:'flex', 
            flexDirection:'row'}}>
        {props.title}
        </Box>
        {props.actions && props.actions.map((action:any, index) => {
        return <Button
            key={index}
            variant="contained"
            color="primary"
            size='small'
            disabled={action.disabled ? action.disabled : false}
            startIcon={action.icon}
            onClick={action.action}
            >{action.label}</Button>
        })}
        </AppBar>
        </>
    );
}

export default ModalTitle;